var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { staticClass: "text-xl mb-6" }, [_vm._v("Payment")]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "relative",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.proceedToPayment.apply(null, arguments)
            },
          },
        },
        [
          _c("payment-options", {
            model: {
              value: _vm.form.payment_method,
              callback: function ($$v) {
                _vm.$set(_vm.form, "payment_method", $$v)
              },
              expression: "form.payment_method",
            },
          }),
          _vm._v(" "),
          _c("h2", [_vm._v("Vouchers")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            If you have a voucher code, please enter it below to apply it to your booking.\n        "
            ),
          ]),
          _vm._v(" "),
          _c("form-voucher", { on: { "voucher-applied": _vm.updateBasket } }),
          _vm._v(" "),
          _c("h2", { staticClass: "mt-10" }, [
            _vm._v("Contact Preferences & Terms"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "font-semibold text-gray-600 mt-4" },
            [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("form-toggle", {
                    model: {
                      value: _vm.form.marketing,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "marketing", $$v)
                      },
                      expression: "form.marketing",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-2" }, [
                    _vm._v(
                      "\n                    Contact me with latest news and offers\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.basketHasEvents
                ? [
                    _c(
                      "div",
                      { staticClass: "flex items-center mt-2" },
                      [
                        _c("form-toggle", {
                          model: {
                            value: _vm.form.adult,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "adult", $$v)
                            },
                            expression: "form.adult",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2" }, [
                          _vm._v(
                            "\n                        I confirm that I am at least 18 years of age\n                    "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasError("adult")
                      ? _c(
                          "div",
                          { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.getErrorFor("adult")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center mt-2" },
                [
                  _c("form-toggle", {
                    model: {
                      value: _vm.form.terms,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "terms", $$v)
                      },
                      expression: "form.terms",
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasError("terms")
                ? _c(
                    "div",
                    { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getErrorFor("terms")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.basketHasEvents
                ? [
                    _c(
                      "div",
                      { staticClass: "flex items-center mt-2" },
                      [
                        _c("form-toggle", {
                          model: {
                            value: _vm.form.weather,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "weather", $$v)
                            },
                            expression: "form.weather",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2" }, [
                          _vm._v(
                            "\n                        I have read and agree to the "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary-600 hover:underline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.modal = "weather"
                                },
                              },
                            },
                            [_vm._v("bad weather policy")]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasError("weather")
                      ? _c(
                          "div",
                          { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.getErrorFor("weather")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center mt-2" },
                      [
                        _c("form-toggle", {
                          model: {
                            value: _vm.form.group,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "group", $$v)
                            },
                            expression: "form.group",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2" }, [
                          _vm._v(
                            "\n                        I have read and agree to the "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary-600 hover:underline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.modal = "group"
                                },
                              },
                            },
                            [_vm._v("group booking guest details policy")]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasError("group")
                      ? _c(
                          "div",
                          { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.getErrorFor("group")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-end mt-8" },
            [
              _c("form-button", { attrs: { type: "submit" } }, [
                _vm._v("\n                Continue\n            "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass:
                "absolute z-10 inset-0 bg-translucent-white-75 flex items-center justify-center",
            },
            [_c("preloader")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "modal" } },
        [
          _vm.modal
            ? _c("modal", {
                on: {
                  hide: function ($event) {
                    _vm.modal = false
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", [
                            _c("h2", { staticClass: "mb-2" }, [
                              _vm._v(_vm._s(_vm.modalText["heading"])),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "space-y-6",
                              domProps: {
                                innerHTML: _vm._s(_vm.modalText["body"]),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end mt-6" },
                            [
                              _c(
                                "form-button",
                                {
                                  attrs: { colour: "gray" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return props.hide.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Close\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3569540669
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ml-2" }, [
      _vm._v("\n                    I have read and agree to the "),
      _c(
        "a",
        {
          staticClass: "text-primary-600 hover:underline",
          attrs: { href: "/terms-and-conditions", target: "_blank" },
        },
        [_vm._v("terms and conditions")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }